(function(){
  function run(){
    var root=document.getElementById('MrakAllProductsBrowse');
    if(!root)return;
    var base=window.location.pathname.split('/collections/')[0]||'';
    var u=function(h){return base+'/collections/'+h;};
    var ja=(document.documentElement.lang||'').toLowerCase().indexOf('ja')===0;
    var c=[['tableware','Tableware'],['houseware','Houseware'],['furniture','Furniture'],['pre-order','Pre-order'],['lightweight-shipping-up-to-1kg','Lightweight up to 1kg']];
    var p=[['allo-cloth','Allo Cloth'],['round-table','Round Tables'],['baskets','Baskets'],['gundri-watergrass','Gundri Watergrass']];
    var links=function(a){return a.map(function(v){return '<a href="'+u(v[0])+'">'+v[1]+'</a>';}).join('');};
    root.innerHTML=
      '<div class="mrak-all-products-browse__head"><span>FIND PRODUCTS</span></div>'+ 
      '<div class="mrak-all-products-browse__desktop">'+
        '<div class="mrak-all-products-browse__row"><span class="mrak-all-products-browse__label">COLLECTION</span><div class="mrak-all-products-browse__links">'+links(c)+'</div></div>'+ 
        '<div class="mrak-all-products-browse__row"><span class="mrak-all-products-browse__label">PRODUCT</span><div class="mrak-all-products-browse__links">'+links(p)+'</div></div>'+ 
      '</div>'+ 
      '<div class="mrak-all-products-browse__mobile">'+
        '<a class="mfac-all" href="'+u('all-products')+'">'+(ja?'すべての商品':'All Products')+'</a>'+ 
        '<span class="mfac-label">'+(ja?'コレクションから探す':'BY COLLECTION')+'</span><div class="mfac-links">'+links(c)+'</div>'+ 
        '<span class="mfac-label">'+(ja?'商品カテゴリーから探す':'BY PRODUCT CATEGORY')+'</span><div class="mfac-links">'+links(p)+'</div>'+ 
      '</div>';
    if(!document.getElementById('MrakAllProductsFinalStyles')){
      var s=document.createElement('style');
      s.id='MrakAllProductsFinalStyles';
      s.textContent='@media screen and (max-width:749px){.mfac-all,.mfac-links a{display:inline-block;padding:7px 10px;color:inherit;text-decoration:none;font-size:.72em;line-height:1.35;border:1px solid rgba(0,0,0,.24)}.mfac-all{margin-bottom:18px}.mfac-label{display:block;margin:0 0 8px;font-size:.7em;letter-spacing:.04em;opacity:.7}.mfac-links{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:18px}}';
      document.head.appendChild(s);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);
  else run();
})();